import { Avatar, Box, Typography } from "@mui/material";

export default function InstructorTab(data) {
 console.log(data.data.instructor) // Log the instructor data to verify it's being passed correctly;

  return (
    <Box>
      <Typography variant="h6" mb={2}>About the Instructor</Typography>

      <Box display="flex" gap={2} alignItems="center">
        <Avatar src={"https://i.pravatar.cc/150"} sx={{ width: 70, height: 70 }} />
        <Box>
          <Typography fontWeight={600}>{data.data.instructor?.name ||""}</Typography>
          {/* <Typography fontSize={14} color="text.secondary">{data.instructor.title}</Typography> */}
        </Box>
      </Box>

      <Typography mt={2} fontSize={14} color="text.secondary">
        {data.data.instructor?.bio || "No bio available."}
      </Typography>
    </Box>
  );
}
